import {Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cm-simple-list-preview-popover',
  template: `
    <span *ngIf="list && list.length === 1" class="single-property">{{list[0]}}</span>
    <span class="multiple-properties" *ngIf="list && list.length > 1">
      <cm-popover #popover>
        <cm-popover-action>
          <span class="link">
            <span class="mr-2">Multiple</span>
            <i class="far fa-list-alt"></i>
          </span>
        </cm-popover-action>
        <cm-popover-content>
          <span class="popover-list">
            <span *ngFor="let element of list" class="text-truncate" title="{{element}}">{{element}}</span>
          </span>
        </cm-popover-content>
      </cm-popover>
    </span>
  `,
  styleUrls: ['./simple-list-preview-popover.component.scss']
})
export class SimpleListPreviewPopoverComponent implements OnInit {
  @Input('list') list: string[];

  opened: boolean;
  displayString = '';

  constructor(private _eref: ElementRef) {
  }

  ngOnInit(): void {
    if (this.list) {
      const stringArray = this.list.join(',');
      this.displayString = stringArray.substr(0, 10);
      if (stringArray.length >= 10) {
        this.displayString += '...';
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    const insideWidget = this._eref.nativeElement.contains(e.target);
    if (!insideWidget) {
      this.opened = false;
    }
  }
}
